import _ from "lodash";
import { useTaxStore } from "../../../_store/taxplanStore";
import { numberWithoutComma } from "../../../pages/balance/component/VIDrawerDebt.Main";

export const TabTwoSumIncomeCalculation = (taxData, balanceData) => {
  let salary_Income = numberWithoutComma(
    _.get(taxData, "tax_income", 0) || balanceData?.sum_salary_peryear || 0
  );

  let bonus_Income = Number(
    balanceData?.other_income_list
      ?.filter((item) => item?.option_income_other === "other_bous")
      ?.reduce((total, num) => {
        return total + Number(num?.other_income_peryear || 0);
      }, 0) || 0
  );

  let freeLance_Income = Number(
    taxData?.freelance?.tax_income ||
      balanceData?.other_income_list
        ?.filter((item) => item?.option_income_other === "other_commission")
        ?.reduce((total, num) => {
          return total + Number(num?.other_income_peryear || 0);
        }, 0) ||
      0
  );

  let freeJob_Income = taxData?.freeJob?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_403 = taxData?.tax_403?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_403_balance = Number(
    balanceData?.other_income_list
      ?.filter((item) => item?.option_income_other === "copy_right")
      ?.reduce((total, num) => {
        return total + Number(num?.other_income_peryear || 0);
      }, 0) || 0
  );

  let income_tax_405 = taxData?.tax_405?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_405_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "other_rent_nonviolence")
    ?.reduce((total, num) => {
      return total + Number(num?.other_income_peryear || 0);
    }, 0);

  let income_tax_406_balance = Number(
    balanceData?.other_income_list
      ?.filter((item) => item?.option_income_other === "special_profession")
      ?.reduce((total, num) => {
        return total + Number(num?.other_income_peryear || 0);
      }, 0) || 0
  );

  let income_tax_407 = taxData?.tax_407?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_407_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "contract_business")
    ?.reduce((total, num) => {
      return total + Number(num?.other_income_peryear || 0);
    }, 0);

  let income_tax_408 = taxData?.tax_408?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_408_balance = balanceData?.other_income_list?.filter((item) => {
    return item?.option_income_other === "other_income_other";
  })?.reduce((total, num) => {
    return total + Number(num?.other_income_peryear || 0);
  }, 0);

  let income_tax_408_property = taxData?.tax_408_property?.reduce(
    (total, num) => {
      return total + Number(num?.tax_income || 0);
    },
    0
  );

  let income_tax_404 = taxData?.tax_404?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_404_balance = balanceData?.interest_peryear_list?.reduce(
    (total, num) => {
      return total + Number(num?.interest_peryear || 0);
    },
    0
  );

  let income_tax_404_balance_other = Number(
    balanceData?.other_income_list
      ?.filter((item) => item?.option_income_other === "other_dividend")
      ?.reduce((total, num) => {
        return total + Number(num?.other_income_peryear || 0);
      }, 0) || 0
  );

  // tax_404_stock
  let income_tax_404_stock = taxData?.tax_404_stock?.reduce((total, num) => {
    if (num?.type_job?.label === "หุ้น") {
      return total + Number(num?.dividend || 0) + Number(num?.tax_credit || 0);
    }
    return total + Number(num?.dividend || 0);
  }, 0);

  let income_not_include_tax = _.get(taxData, "income_not_include_tax", 0);

  let RMF_Profit =
    Number(taxData?.RMF_Profit?.selling_price || 0) -
    Number(taxData?.RMF_Profit?.cost_price || 0);
  let SSF_Profit =
    Number(taxData?.SSF_Profit?.selling_price || 0) -
    Number(taxData?.SSF_Profit?.cost_price || 0);

  let Income_42_26 = 0;
  let Income_42_27 = 0;
  let Income_42_28 = 0;

  if (!taxData?.heritage?.tax_calc_include) {
    Income_42_26 = Number(taxData?.heritage?.income_42_26 || 0);
    Income_42_27 = Number(taxData?.heritage?.income_42_27 || 0);
    Income_42_28 = Number(taxData?.heritage?.income_42_28 || 0);
  }

  let tax408_property = taxData?.tax_408_property?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let tax408_property_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "other_income_selling")
    ?.reduce((total, num) => {
      return total + Number(num?.other_income_peryear || 0);
    }, 0);

  return (
    Number(salary_Income || 0) +
    Number(bonus_Income || 0) +
    Number(freeJob_Income || 0) +
    Number(freeLance_Income || 0) +
    Number(income_tax_403 || 0) +
    Number(income_tax_403_balance || 0) +
    Number(income_tax_405 || 0) +
    Number(income_tax_405_balance || 0) +
    Number(income_tax_406_balance || 0) +
    Number(income_tax_407 || 0) +
    Number(income_tax_407_balance || 0) +
    Number(income_tax_408 || 0) +
    Number(income_tax_408_balance || 0) +
    Number(income_tax_404 || 0) +
    Number(income_tax_404_balance || 0) +
    Number(income_tax_404_balance_other || 0) +
    Number(income_tax_404_stock || 0) +
    Number(income_not_include_tax || 0) +
    Number(RMF_Profit || 0) +
    Number(SSF_Profit || 0) +
    Number(Income_42_26 || 0) +
    Number(Income_42_27 || 0) +
    Number(Income_42_28 || 0) +
    Number(tax408_property || 0) +
    Number(tax408_property_balance || 0)
  );
};

export const TabTwoExpenseCalculation = (taxData, balanceData) => {
  let salary_expense =
    numberWithoutComma(_.get(taxData, "tax_income", 0) || 0) / 2 > 100000
      ? 100000
      : numberWithoutComma(_.get(taxData, "tax_income", 0) || 0) / 2;

  let freelanceIncome = numberWithoutComma(
    taxData?.freelance?.tax_income ||
      balanceData?.other_income_list
        ?.filter((item) => item?.option_income_other === "other_commission")
        ?.reduce((total, num) => {
          return total + Number(num?.other_income_peryear || 0);
        }, 0) ||
      0
  );

  //40(1)+40(2)
  let sumIncomeSalaryAndFreelance =
    (numberWithoutComma(_.get(taxData, "tax_income", 0) || 0) +
      numberWithoutComma(freelanceIncome || 0)) /
      2 >
    100000
      ? 100000
      : (numberWithoutComma(_.get(taxData, "tax_income", 0) || 0) +
          numberWithoutComma(freelanceIncome || 0)) /
        2;

  let income_tax_406_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "special_profession")
    ?.reduce((total, num) => {
      if (num?.calculating_method === "หักแบบเหมา") {
        return (
          total +
          (Number(num?.other_income_peryear || 0) -
            Number(num?.income_for_calculating_all_in || 0))
        );
      }
      if (num?.calculating_method === "หักตามจริง") {
        return total + Number(num?.Tax_Real || 0);
      }
      return total + 0;
    }, 0);

  //   วิชาชีพอิสระ
  let freeJob_expense = taxData?.freeJob?.reduce((total, num) => {
    if (num?.calculating_method === "หักแบบเหมา") {
      return (
        total +
        (Number(num?.tax_income || 0) -
          Number(num?.income_for_calculating_all_in || 0))
      );
    }
    if (num?.calculating_method === "หักตามจริง") {
      return (
        total +
        (Number(num?.tax_income || 0) -
          Number(num?.income_for_calculating || 0))
      );
    }
    return total + 0;
  }, 0);

  //   40(3)
  let expense_tax_403 = taxData?.tax_403?.reduce((total, num) => {
    if (num?.calculating_method === "หักแบบเหมา") {
      return (
        total +
        Number(num?.tax_income || 0) -
        Number(num?.income_for_calculating_all_in || 0)
      );
    }
    if (num?.calculating_method === "หักตามจริง") {
      return (
        total +
        (Number(num?.tax_income || 0) -
          Number(num?.income_for_calculating || 0))
      );
    }
    return total + 0;
  }, 0);

  //   40(3) balance
  let expense_tax_403_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "copy_right")
    ?.reduce((total, num) => {
      if (num?.calculating_method === "หักแบบเหมา") {
        return (
          total +
          Number(num?.other_income_peryear || 0) -
          Number(num?.income_for_calculating_all_in || 0)
        );
      }
      if (num?.calculating_method === "หักตามจริง") {
        return total + Number(num?.Tax_Real || 0);
      }
      return total + 0;
    }, 0);

  //   40(5)
  let expense_tax_405 = taxData?.tax_405?.reduce((total, num) => {
    if (num?.calculating_method === "หักแบบเหมา") {
      return (
        total +
        (Number(num?.tax_income || 0) -
          Number(num?.income_for_calculating_all_in || 0))
      );
    }
    if (num?.calculating_method === "หักตามจริง") {
      return (
        total +
        (Number(num?.tax_income || 0) -
          Number(num?.income_for_calculating || 0))
      );
    }
    return total + 0;
  }, 0);

  //   40(5) balance
  let expense_tax_405_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "other_rent_nonviolence")
    ?.reduce((total, num) => {
      if (num?.calculating_method === "หักแบบเหมา") {
        return (
          total +
          Number(num?.other_income_peryear || 0) -
          Number(num?.income_for_calculating_all_in || 0)
        );
      }
      if (num?.calculating_method === "หักตามจริง") {
        return total + Number(num?.Tax_Real || 0);
      }
      return total + 0;
    }, 0);

  //   40(7)
  let expense_tax_407 = taxData?.tax_407?.reduce((total, num) => {
    if (num?.calculating_method === "หักแบบเหมา") {
      return (
        total +
        (Number(num?.tax_income || 0) -
          Number(num?.income_for_calculating_all_in || 0))
      );
    }
    if (num?.calculating_method === "หักตามจริง") {
      return (
        total +
        (Number(num?.tax_income || 0) -
          Number(num?.income_for_calculating || 0))
      );
    }
    return total + 0;
  }, 0);

  //   40(7) balance
  let expense_tax_407_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "contract_business")
    ?.reduce((total, num) => {
      if (num?.calculating_method === "หักแบบเหมา") {
        return (
          total +
          Number(num?.other_income_peryear || 0) -
          Number(num?.income_for_calculating_all_in || 0)
        );
      }
      if (num?.calculating_method === "หักตามจริง") {
        return total + Number(num?.Tax_Real || 0);
      }
      return total + 0;
    }, 0);

  //   40(8)
  let expense_tax_408 = taxData?.tax_408?.reduce((total, num) => {
    if (num?.calculating_method === "หักแบบเหมา") {
      return (
        total +
        (Number(num?.tax_income || 0) -
          Number(num?.income_for_calculating_all_in || 0))
      );
    }
    if (num?.calculating_method === "หักตามจริง") {
      return (
        total +
        (Number(num?.tax_income || 0) -
          Number(num?.income_for_calculating || 0))
      );
    }
    return total + 0;
  }, 0);

  //   40(8) balance
  let expense_tax_408_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "other_income_other")
    ?.reduce((total, num) => {
      if (num?.calculating_method === "หักแบบเหมา") {
        return (
          total +
          Number(num?.other_income_peryear || 0) -
          Number(num?.income_for_calculating_all_in || 0)
        );
      }
      if (num?.calculating_method === "หักตามจริง") {
        return total + Number(num?.Tax_Real || 0);
      }
      return total + 0;
    }, 0);

  //   40(8)_property
  let expense_tax_408_property = taxData?.tax_408_property?.reduce(
    (total, num) => {
      if (num?.calculating_way === "ไม่แยกคำนวณ") {
        if (num?.calculating_method === "หักแบบเหมา") {
          return (
            total +
            (Number(num?.tax_income || 0) -
              Number(num?.income_for_calculating_all_in || 0))
          );
        }
        if (num?.calculating_method === "หักตามจริง") {
          return (
            total +
            (Number(num?.tax_income || 0) -
              Number(num?.income_for_calculating || 0))
          );
        }
      }
      return total + 0;
    },
    0
  );

  let expense_tax_408_property_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "other_income_selling")
    ?.reduce((total, num) => {
      if (num?.calculating_way === "ไม่แยกคำนวณ") {
        if (num?.calculating_method === "หักแบบเหมา") {
          return (
            total +
            (Number(num?.other_income_peryear || 0) -
              Number(num?.income_for_calculating_all_in || 0))
          );
        }
        if (num?.calculating_method === "หักตามจริง") {
          return total + Number(num?.Tax_Real || 0);
        }
      }
      return total + 0;
    }, 0);

  let sumExpense =
    Number(sumIncomeSalaryAndFreelance || 0) +
    Number(freeJob_expense || 0) +
    Number(expense_tax_403 || 0) +
    Number(expense_tax_403_balance || 0) +
    Number(expense_tax_405 || 0) +
    Number(expense_tax_405_balance || 0) +
    Number(income_tax_406_balance || 0) +
    Number(expense_tax_407 || 0) +
    Number(expense_tax_407_balance || 0) +
    Number(expense_tax_408 || 0) +
    Number(expense_tax_408_balance || 0) +
    Number(expense_tax_408_property || 0) +
    Number(expense_tax_408_property_balance || 0);

  return sumExpense;
};
